var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "clock",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_13378",
    "data-name": "Path 13378",
    d: "M23.521,8.953H22.454V14.89l3.854,1.832.458-.963-3.245-1.542Z",
    transform: "translate(-15.004 -6.303)",
    fill: "#868a97"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13379",
    "data-name": "Path 13379",
    d: "M9.5,1.5a8,8,0,1,0,8,8A8,8,0,0,0,9.5,1.5Zm0,14.933A6.933,6.933,0,1,1,16.433,9.5,6.933,6.933,0,0,1,9.5,16.433Z",
    transform: "translate(-1.5 -1.5)",
    fill: "#868a97"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockGrey);
export default __webpack_public_path__ + "static/media/clockGrey.ab6c0a9abbf77046fd44d80ab469f815.svg";
export { ForwardRef as ReactComponent };